module.exports = __webpack_public_path__ + "static/media/audio_upload_icon.90c2a903.svg";